import { gql } from '@apollo/client';

const Fragments = {
  person: gql`
    fragment person on AllocationPerson {
      personId
      lastName
      firstName
    }
  `
};

export default Fragments;
